define('shared/util/dom/observer/remove',['shared/lib/RSVP'], function(RSVP){
    'use strict';

    var g = this;

    return function( target ){
        return new RSVP.Promise(function(resolve){
            if ( g.MutationObserver ) {
                var mo = new MutationObserver(function(mutations){
                    mutations.forEach(function(mutation) {
                        if ( mutation.type == 'childList' ) {
                            for( var l = mutation.removedNodes.length; l--; ) {
                                var node = mutation.removedNodes[l];
                                if ( node == target ) {
                                    mo.disconnect();
                                    if ( target == null || target.parentNode == null ) {
                                        resolve();
                                    }
                                }
                            }
                        }
                    });   
                });
                mo.observe( target.parentNode, {childList: true} );
            }
            else {
                (function loop(){
                    if ( target == null || target.parentNode == null ) {
                        resolve();
                        return;
                    }
                    setTimeout(loop, 500);
                })();
            }
        });
    };
});

